/* Forever Noor — Floating Video Popup JS */
(function () {
  'use strict';

  const STORAGE_KEY = 'fn_video_popup_seen';

  function init() {
    const launcher  = document.getElementById('fn-video-launcher');
    const popup     = document.getElementById('fn-video-popup');
    const closeBtn  = document.getElementById('fn-video-close');
    const thumbVid  = document.getElementById('fn-launcher-video');
    const mainVid   = document.getElementById('fn-popup-video');

    if (!launcher || !popup) return;

    // Auto-open once per session if not seen before
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      setTimeout(openPopup, 3000);
    }

    launcher.addEventListener('click', function () {
      if (popup.classList.contains('fn-open')) {
        closePopup();
      } else {
        openPopup();
      }
    });

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closePopup();
    });

    function openPopup() {
      popup.classList.add('fn-open');
      launcher.style.display = 'none';
      sessionStorage.setItem(STORAGE_KEY, '1');
      if (mainVid) {
        mainVid.muted = false;
        mainVid.play().catch(function () {
          mainVid.muted = true;
          mainVid.play();
        });
      }
    }

    function closePopup() {
      popup.classList.remove('fn-open');
      launcher.style.display = '';
      if (mainVid) { mainVid.pause(); mainVid.currentTime = 0; }
      if (thumbVid) { thumbVid.play(); }
    }

    // Start thumb preview
    if (thumbVid) { thumbVid.play().catch(function(){}); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
